import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { LoaderService } from 'app/loader.service';
import { HubService } from 'app/hub.service';
import { ApiService } from 'app/api.service';
import { Ng2Highcharts } from 'ng2-highcharts';
import { ChartsService } from 'app/charts.service';
import { Angulartics2 } from 'angulartics2';
declare var alertify: any;

@Component({
  selector: 'app-workout-list',
  templateUrl: './workout-list.component.html',
  styleUrls: ['./workout-list.component.scss']
})
export class WorkoutListComponent implements OnInit {

  workouts: Array<any> = [];
  profileChartOptions: any;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private loaderService: LoaderService,
    private apiService: ApiService,
    private hubService: HubService,
    private chartsService: ChartsService,
    private angulartics2: Angulartics2
  ) { }

  ngOnInit() {
    this.getWorkouts();
  }

  // load staff workouts
  getWorkouts() {
    // let where = {
    //   "category": {
    //     $in:[
    //       {
    //         __type: 'Pointer',
    //         className: 'Category',
    //         objectId: 'eVzYj8NQ9j'
    //       },
    //     ]
    //   },
    //   // "type": "segments"
    // }

    let where = {
      "category": {
        $in:[
          {
            __type: 'Pointer',
            className: 'Category',
            objectId: 'c-my-workouts'
          },
          // {
          //   __type: 'Pointer',
          //   className: 'Category',
          //   objectId: 'eVzYj8NQ9j'
          // },
        ]
      },
      // "type": {
      //   $in: ["segments", "dynamicTest", "route"]
      //   // $in: ["segments"]
      // }
    }
    let limit = 300;
    let skip = null;
    let orderBy = 'title';
    let includes = ['author'];

    this.hubService.getResource('Workout', where, limit, skip, orderBy, includes).subscribe(
      workouts => {
        // console.log(workouts);
        // console.log(JSON.stringify(workouts[workouts.length-1]));
        this.workouts = workouts;
        this.loaderService.setLoaded();

        for (let i = 0; i < workouts.length; i++) {
          if(workouts[i].type === "segments"){
            this.buildProfile(workouts[i], 'ftp');
          }
        }
      },
      error => {
        // console.log(error);
      }
    );
  }

  // load staff workouts
  deleteWorkout(objectId:string = null) {

    if(!objectId){return;}

    this.hubService.deleteResource('Workout', objectId).subscribe(
      workouts => {
        // console.log("deleted");
        this.angulartics2.eventTrack.next({ action: 'Workout Deleted', properties: { category: 'Workouts' }});
        this.workouts = [];
        this.loaderService.setLoading();
        this.getWorkouts();
      },
      error => {
        // console.log(error);
      }
    );
  }

  // load staff workouts
  toggleHidden(objectId:string = null, hidden:boolean = true) {

    if(!objectId){return;}

    let payload = {};
    let $this = this;

    alertify.confirm("Are you sure you want to delete this Workout?", function () {
      if(hidden) {
        payload = {hidden: false};
      } else {
        payload = {hidden: true};
      }

      $this.hubService.putResource('Workout', objectId, payload).subscribe(
        workouts => {
          this.loaderService.setLoading();
          this.workouts = [];
          $this.getWorkouts();
        },
        error => {
          // console.log(error);
          alertify.error(error.message);
        }
      );
    }, function() {
      return false;
    });
  }

  buildProfile(workout, workoutType) {
    var workoutProfileObject = {};
    var workoutType = workoutType;
    var zonePowerTimes = [];
    if (workoutType == 'mmp') {
      workoutProfileObject = { 0: [], 1: [], 2: [], 3: [], 4: [], 5: [], 6: [], 7: [] }; // TODO: why did I use an object?
      zonePowerTimes = [0, 0, 0, 0, 0, 0, 0, 0];
    } else {
      workoutProfileObject = { 0: [], 1: [], 2: [], 3: [], 4: [], 5: [] }; // TODO: why did I use an object?
      zonePowerTimes = [0, 0, 0, 0, 0, 0];
    }
    var runningDuration = 0;
    var plotLinesLaps = [];

    // loop the segments and create the profile array data for highcharts
    for (var i = 0; i < workout['segments'].length; i++) {

      // add to the laps array if needed
      if (workout['segments'][i].lap === true) {
        plotLinesLaps.push({
          color: "rgba(0, 0, 0, .2)",
          dashStyle: "Dash",
          value: (runningDuration),
          width: "1",
          zIndex: 22,
          label: { enabled: false }
        });
      }

      // what zone is this segment
      let segmentZone = this.getMmpPowerZone(workout['segments'][i].start, 'ftp');

      // loop through the zones arrays and add this segment to the correct array and NULL
      // to the others to create breaks/gaps. This is so we can use miltiple series and so multiple colours
      for (var key in workoutProfileObject) {
        if (key != segmentZone.toString()) {
          workoutProfileObject[segmentZone].push([runningDuration, null]);
        } else {
          // profile
          workoutProfileObject[segmentZone].push([runningDuration, workout['segments'][i].start]);
          runningDuration += workout['segments'][i].duration;
          workoutProfileObject[segmentZone].push([runningDuration, workout['segments'][i].start]);
          // time in zone
          zonePowerTimes[segmentZone] += workout['segments'][i].duration;
        }
      }

    }

    // get the configs
    workout.profileChartOptions = this.chartsService.workoutProfileChart(workoutProfileObject, workoutType, plotLinesLaps);

    workout.profileChartOptions.chart.backgroundColor = 'transparent';
    workout.profileChartOptions.chart.height = 50;
    workout.profileChartOptions.xAxis[0].visible = false;
    workout.profileChartOptions.yAxis[0].visible = false;
  }

  getMmpPowerZone(percentMmpPower, workoutType) {

    const mmpPowerBands = [0, 35, 45, 55, 65, 75, 85, 100, 1000];
    const ftpPowerBands = [0, 55, 75, 90, 105, 120, 150, 1000];
    // const mmpHrBands = [0, 60, 65, 75, 82, 89, 94, 100, 1000];
    // const ftpHrBands = [0, 60, 65, 75, 82, 89, 94, 100, 1000];

    if (workoutType == 'ftp') {
      if (percentMmpPower > ftpPowerBands[0] && percentMmpPower < ftpPowerBands[1]) { return 0; }
      else if (percentMmpPower >= ftpPowerBands[1] && percentMmpPower <= ftpPowerBands[2]) { return 1; }
      else if (percentMmpPower >= ftpPowerBands[2] && percentMmpPower <= ftpPowerBands[3]) { return 2; }
      else if (percentMmpPower >= ftpPowerBands[3] && percentMmpPower <= ftpPowerBands[4]) { return 3; }
      else if (percentMmpPower >= ftpPowerBands[4] && percentMmpPower <= ftpPowerBands[5]) { return 4; }
      else if (percentMmpPower >= ftpPowerBands[5] && percentMmpPower <= ftpPowerBands[6]) { return 5; }
      else { return 0; }
    } else {
      if (percentMmpPower > mmpPowerBands[0] && percentMmpPower < mmpPowerBands[1]) { return 0; }
      else if (percentMmpPower >= mmpPowerBands[1] && percentMmpPower <= mmpPowerBands[2]) { return 1; }
      else if (percentMmpPower >= mmpPowerBands[2] && percentMmpPower <= mmpPowerBands[3]) { return 2; }
      else if (percentMmpPower >= mmpPowerBands[3] && percentMmpPower <= mmpPowerBands[4]) { return 3; }
      else if (percentMmpPower >= mmpPowerBands[4] && percentMmpPower <= mmpPowerBands[5]) { return 4; }
      else if (percentMmpPower >= mmpPowerBands[5] && percentMmpPower <= mmpPowerBands[6]) { return 5; }
      else if (percentMmpPower >= mmpPowerBands[6] && percentMmpPower <= mmpPowerBands[7]) { return 6; }
      else if (percentMmpPower >= mmpPowerBands[7] && percentMmpPower <= mmpPowerBands[8]) { return 7; }
      else { return 0; }
    }

  }

  onClickWorkout(event, workout) {
    if (event.type == 'click') {
      let target = event.target.tagName.toLowerCase();

      if (target != 'button') {
        this.router.navigate(['/workouts/view/', workout.objectId])
      }
    }
  }

}



// WEBPACK FOOTER //
// /tmp/build_769bc651/src/app/workout-list/workout-list.component.ts